const NotificationTypes = {
  INFO:    'info',
  SUCCESS: 'success',
  WARNING: 'warning',
  ERROR:   'error'
};

export default NotificationTypes;
